import { motion } from "framer-motion";
import {
  Box,
  Card,
  Image,
  Text,
  Badge,
  Button,
  Group,
  Modal,
  Divider,
  Tooltip,
} from "@mantine/core";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import { withAuthenticator } from "@aws-amplify/ui-react";
import { IconCopy, IconBrandTwitch, IconCheck } from "@tabler/icons";
import { SelectedContext } from "../Contexts/SelectedContext";
import { useClipboard } from "@mantine/hooks";
import Tutorial from "./Tutorial";
import { useMediaQuery } from "@mantine/hooks";
import { Check, Copy } from "tabler-icons-react";
const featuredCampaigns = [
  {
    src: "https://adly-campaigns.s3.eu-north-1.amazonaws.com/nope.jpg",
    title: "United International Pictures",
    date: "2022.08.05 - 2022.09.01",
  },
  {
    src: "https://adly-campaigns.s3.eu-north-1.amazonaws.com/PRICERUNNER_BIG.png",
    title: "PriceRunner Ladder",
    date: "2022.05.15 - 2022.07.12",
  },
  {
    src: "https://campaignmedia-adly.s3.eu-north-1.amazonaws.com/3i3btqxmuhmxjp2/1667204439164_campaing-coupon-384x256-V3+%281%29.jpg",
    title: "Voon - Nicotine & Tobacco Free",
    date: "2022.09.12 - 2022.12.12",
  },
  {
    src: "https://adly-campaigns.s3.eu-north-1.amazonaws.com/godzilla-vs-kong.jpg",
    title: "Godzilla vs Kong",
    date: "2021.05.15 - 2021.06.10",
  },
];

function HomePage({ user, signOut }) {
  const navigate = useNavigate();
  // const { setTwitchLinked } = useContext(LinkedContext);
  const matches = useMediaQuery("(min-width: 800px)");
  const { setSelected } = useContext(SelectedContext);

  const [oauth, setOauth] = useState();
  const [linked, setLinked] = useState(true);
  const [reload, setReload] = useState(true);
  const [openedModal, setOpenedModal] = useState(linked);
  const [opened, setOpened] = useState(false);
  const [userId, setUserId] = useState();
  const [name, setName] = useState("");
  const [active, setActive] = useState(1);
  const [obsId, setObsId] = useState("");
  const [copyState, setCopyState] = useState(false);
  const clipboard = useClipboard();
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    // console.log(user);
    setOauth(document.location.hash.substring(14, 44));
  }, [user]);

  useEffect(() => {
    Axios.post(
      "https://t7c8o2mj57.execute-api.eu-north-1.amazonaws.com/dev/",
      {
        email: user.attributes.email,
      },
      {
        headers: {
          Authorization: user.signInUserSession.idToken.jwtToken,
        },
      }
    ).then((res) => {
      setSelected(res.data);
      setLinked(res.data);
      //console.log("CAMPAIGNS: " + res.data)
    });
  }, [reload, user, setSelected, setLinked]);


//   const timeId = setTimeout(() => {
//     setIsCopied(false);
//   }, 3000);

  useEffect(() => {
    Axios.post("https://uhgprk5250.execute-api.eu-north-1.amazonaws.com/dev/", {
      email: user.attributes.email,
    }).then((res) => {
      setUserId(res.data.id);
      if (res.data.twitchData[0].display_name) {
        setName(res.data.twitchData[0].display_name);
      }
      setObsId(res.data.unique_id);
    });
  }, [user]);

  useEffect(() => {
    if (oauth) {
      // console.log(oauth);
      Axios.get("https://api.twitch.tv/helix/users", {
        headers: {
          "Client-Id": "wwm7b8ypaux68ao38xb9qxgiw213nq",
          Authorization: `Bearer ${oauth}`,
        },
      }).then((res) => {
        // console.log(res);
        Axios.post(
          "https://wgzn2aqiah.execute-api.eu-north-1.amazonaws.com/dev/",
          {
            jwt: user.signInUserSession.idToken.jwtToken,
            auth: oauth,
          }
        ).then((data) => {
          // console.log(data);
          setReload(!reload);
          navigate("/");
        });
      });
    }
  }, [oauth, navigate, user]);

  if (linked) {
    return (
      <>
        <div>
          <Modal
            size={853}
            margin={0}
            padding={0}
            opened={opened}
            onClose={() => setOpened(false)}
            overflow="outside"
            lockScroll
            transitionDuration={500}
            transitionTimingFunction="ease-in-out"
          >
            <Tutorial obsId={obsId} setOpened={setOpened} />
          </Modal>
          <div
            style={{
              display: matches ? "flex" : "block",
              justifyContent: "space-evenly",
              alignItems: "center",
              padding: 10,
            }}
          >
            <div style={{ maxWidth: 450 }}>
              <Text size="28px" weight={600}>
                Hi, {name}
              </Text>
              <Text color="dimmed" size={16}>
                Welcome to your streaming dashboard!
              </Text>
            </div>
            <Card
              shadow="sm"
              p="xl"
              m="lg"
              radius="md"
              withBorder
              style={{
                minHeight: "200px",
                minWidth: "35%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.2)",
              }}
            >
              <div>
                <div
                  style={{
                    maxWidth: "500px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ justifyContent: "center" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Text
                        m="sm"
                        weight={600}
                        style={{ width: "100%" }}
                        mb={0}
                      >
                        Copy Your Streaming Code
                      </Text>
                      {isCopied ? (
                        <Check
                          style={{
                            color: "#54EDB7",
                            borderRadius: 10,
                            backgroundColor: "#ECFEF6",
                            padding: 10,
                          }}
                          size={50}
                        />
                      ) : (
                        <Copy
                          style={{
                            cursor: "pointer",
                            color: "#5fa6ec",
                            borderRadius: 10,
                            backgroundColor: "#edf7fe",
                            padding: 10,
                          }}
                          size={50}
                          onClick={() => {
                            clipboard.copy(
                              `http://d1zgkh7btyfdg4.cloudfront.net/${obsId}`
                            );
                            setIsCopied(true);
                            //timeId();
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div
                    style={{
                      display: "flex",
                      position: "absolute",
                      bottom: "20px",
                    }}
                  >
                    <Text size={"xs"} weight={400} ml={"sm"} mt={0}>
                      Tutorial on how to join paid sponsorships
                    </Text>
                    <div style={{ display: "flex" }}>
                      <Text
                        size={"xs"}
                        weight={800}
                        ml={"3px"}
                        mt={0}
                        style={{
                          cursor: "pointer",
                          backgroundColor: "#edf7fe",
                          color: "#5fa6ec",
                          minWidth: "2vw",
                        }}
                        onClick={() => {
                          setOpened(true);
                        }}
                      >
                        here
                      </Text>
                      <Text size={"xs"} weight={400} ml={0} mt={0} mr={"sm"}>
                        .
                      </Text>
                    </div>
                  </div>
                  {/* <Button
                      variant="light"
                      radius="sm"
                      size="xs"
                      m="sm"
                      ml={0}
                      onClick={() => {
                        setOpened(true);
                      }}
                    >
                      30 Seconds Tutorial
                    </Button> */}
                </div>
              </div>
            </Card>
          </div>
          <Divider ml={"5%"} mr={"5%"} size="md" mt={40} />
          <div
            style={{ marginBottom: "10px", paddingTop: 20, marginLeft: "5%" }}
          >
            <Text size={20} weight={700}>
              Previous Sponsorships
            </Text>
            <Text size={14}>
              Interested in working with prominent brands from across the globe?
            </Text>
          </div>
          <div style={{ marginLeft: "5%" }}>
            {featuredCampaigns.map((c, index) => {
              return (
                <motion.div
                  style={{
                    width: "300px",
                    display: "inline-block",
                    paddingRight: "20px",
                    paddingBottom: "20px",
                    marginRight: 10,
                    opacity: "75%",
                  }}
                  key={index}
                >
                  <div>
                    <Card
                      shadow="sm"
                      p="lg"
                      radius="md"
                      withBorder
                      style={{ height: "300px" }}
                    >
                      <Card.Section>
                        <Image
                          src={c.src}
                          withPlaceholder
                          placeholder={
                            <Text align="center" size="sm" weight={700}>
                              No Image
                            </Text>
                          }
                          height={160}
                          alt="Voon"
                        />
                      </Card.Section>
                      <Group position="apart" mt="md" mb="xs">
                        <Text weight={500}>{c.title}</Text>
                      </Group>
                      <Group position="center" mb="xs">
                        <Badge>Finished</Badge>
                      </Group>
                      <Divider />
                      <Group position="center" mt="md" mb="xs">
                        <Text lineClamp={3} size="sm" color="dimmed">
                          {c.date}
                        </Text>
                      </Group>
                    </Card>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </>
    );
  } else {
    return (
      <div className="App">
        <Modal opened={openedModal} withCloseButton={false}>
          <Text size={20} weight={700}>
            Welcome,
          </Text>
          <Divider my="sm" />
          <Text size={18} weight={400}>
            Link your Twitch account to join sponsorship deals.
          </Text>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Tooltip label="Click to link account">
              <Button
                mt="xl"
                color="grape"
                leftIcon={<IconBrandTwitch />}
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href =
                    "https://id.twitch.tv/oauth2/authorize?response_type=token&client_id=wwm7b8ypaux68ao38xb9qxgiw213nq&redirect_uri=https://streamer.adly.gg&scope=user%3Aedit+moderator%3Aread%3Achatters+channel%3Amanage%3Amoderators";
                  // console.log(document.location.hash);
                  setOauth(document.location.hash);
                }}
              >
                Link Account
              </Button>
            </Tooltip>
          </div>
          <Tooltip label="Logout">
            <Button variant="outline" mt="xl" mr="md" onClick={signOut}>
              Cancel
            </Button>
          </Tooltip>
        </Modal>
      </div>
    );
  }
}

export default withAuthenticator(HomePage);
